import { BaseService } from './BaseService';
import { Statistic } from '../models';

// Statistic Service
export class StatisticService extends BaseService {
  constructor() {
    super();
  }

  /**
   * Fetch statistics for the currently authenticated user
   * @returns {Promise<Statistic>} Parsed Statistic model
   */
  async getUserStatistics(period = 'global') {
    const response = await this.post('/statistics/user', { period });
    return new Statistic(response.data);
  }

  /**
   * Fetch statistics for the current enterprise (if the user has permission)
   * @param {string} period
   * @param {string} [enterpriseId] Optional selected enterprise ID
   * @returns {Promise<Statistic>} Parsed Statistic model
   */
  async getEnterpriseStatistics(period = 'global', enterpriseId) {
    const body = enterpriseId ? { period, enterpriseId } : { period };
    const response = await this.post('/statistics/enterprise', body);
    return new Statistic(response.data);
  }
} 